<template>
<b-container fluid class="container">
<div>
  <b-img src="../assets/tres.png" class="imgIco1" fluid></b-img>
  <b-img src="../assets/step3.png" class="imgStepper12" fluid></b-img>
</div>
<div>
  <b-card overlay class="step3">
  <div class="col-lg-8 mt-2">
    <b-row align-h="center">
      <b-col lg="12" class="text-left">
        <b-row cols="2">
          <b-col cols="12"><h1 class="titulo" style="color: #3B3B3B">Por último <span style="color: #A50932">tu domicilio</span></h1></b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
  <b-img src="../assets/step3.png" class="imgStepper2" fluid alt="stepper1"></b-img>
  <div class="col-lg-9 mt-3">
    <p class="parrafo" style="color: #3B3B3B;">Ingresa tu dirección tal como aparece en el <span style="color: #A50932">comprobante de domicilio.</span></p>
  </div>
  <div class="col-lg-4 mt-2 ml-4 text-left">
    <b-row cols="1">

      <b-col class="mt-2">
        <b-form-input id="input-1" v-model="codigoPostal" @change="entidades()" class="text" placeholder="Código Postal" maxlength="5" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" required></b-form-input>
      </b-col>
      <b-col v-if="this.codigoPostal == null ">
        <p class="ml-2" style="color: #A50932; font-size: 14px; font-weight: bolder;">Ingresa tu código postal.</p>
      </b-col>
      
      <b-col class="mt-2" v-if="this.codigoPostal != null && this.local == true">
        <select v-model="colonia" class="select">
          <option selected disabled value=null>Selecciona la colonia</option>
          <option v-for="colonia in colonias" :key="colonia.colonia">{{ colonia.colonia }}</option>
        </select>
      </b-col>

      <b-col class="mt-2" v-if="this.codigoPostal != null && this.copomex == true">
        <select v-model="colonia" class="select">
          <option selected disabled value=null>Selecciona la colonia</option>
          <option v-for="colonia in colonias" :key="colonia">{{ colonia }}</option>
        </select>
      </b-col>

      <b-col v-if="this.codigoPostal != null && this.colonia == null">
        <p class="ml-2" style="color: #A50932; font-size: 14px; font-weight: bolder;">Ingresa la colonia donde vives.</p>
      </b-col>

        <b-col class="mt-2" v-if="this.codigoPostal != null && this.colonia != null"><b-form-input id="input-3" v-model="alcaldia" class="text" placeholder="Ciudad / Localidad" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" required></b-form-input></b-col>
        <b-col class="mt-2" v-if="this.codigoPostal != null && this.colonia != null"><b-form-input id="input-4" v-model="entidadFederativa" class="text" placeholder="Estado" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" required></b-form-input></b-col>
        <b-col class="mt-2" v-if="this.codigoPostal != null && this.colonia != null"><b-form-input id="input-1" v-model="calle" class="text" placeholder="Calle" required></b-form-input></b-col>
        <b-col v-if="this.calle == null && this.colonia != null">
          <p class="ml-2" style="color: #A50932; font-size: 14px; font-weight: bolder;">Ingresa la calle donde vives.</p>
        </b-col>
    </b-row>  
  </div>

  <div class="col-lg-4 mt-2 ml-4 text-left datos3" v-if="this.codigoPostal != null && this.colonia != null">
      <b-row cols="1">
        <b-col class="mt-2" v-if="this.calle != null && this.colonia != null"><b-form-input id="input-1" v-model="numeroExterior" class="textC" placeholder="Num. exterior" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" maxlength="10" required></b-form-input></b-col>
        <b-col v-if="this.calle != null && this.colonia != null && this.numeroExterior == null">
          <p class="ml-2" style="color: #A50932; font-size: 14px; font-weight: bolder;">Ingresa el número exterior donde vives.</p>
        </b-col>
        <b-col class="mt-2" v-if="this.calle != null && this.colonia != null && this.numeroExterior != null"><b-form-input id="input-1" v-model="numeroInterior" class="textC" placeholder="Num. interior" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57))" maxlength="10" required></b-form-input></b-col>
        <b-col v-if="this.calle != null && this.colonia != null  && this.numeroExterior != null && this.numeroInterior == null">
          <p class="ml-2" style="color: #A50932; font-size: 14px; font-weight: bolder;">Ingresa el número interior donde vives.</p>
        </b-col>
      </b-row>
  </div>

      <b-modal v-model="modalShow" size="sm" hide-footer>
        <template #modal-title>
          Error de Datos
        </template>
          <div class="d-block">
            <b-alert v-if="this.errorDatos == true" show variant="warning"><p class="text-center" style="color: #A50932; font-size: 15px;">¡ Datos Incompletos !</p></b-alert>
            <b-alert v-if="this.errorCodigo == true" show variant="warning"><p class="text-center" style="color: #A50932; font-size: 15px;">¡ Código Postal Incorrecto !</p></b-alert>
          </div>
      </b-modal>

  <div class="col-lg-12 boton3" >
    <b-button @click.prevent="regresar()" class="button mt-2"><b-icon icon="chevron-left" aria-hidden="true"></b-icon>Regresar</b-button>
    <b-button v-if="this.calle != null && this.numeroExterior != null  && this.colonia != null && this.codigoPostal != null && this.alcaldia != null && this.entidadFederativa != null" @click.prevent="continuar()" class="button mt-2">Siguiente <b-icon icon="chevron-right" aria-hidden="true"></b-icon></b-button>
  </div>
  </b-card>
</div>

</b-container>
</template>

<script>

export default {
  name: 'DatosDomicilio',

  components: {

  },

    data() {
    return {
        codigoPostal: sessionStorage.getItem("codigoPostal"),
        calle: sessionStorage.getItem("calle"),
        numeroExterior: sessionStorage.getItem("numExt"),
        numeroInterior: sessionStorage.getItem("numInt"),
        colonia: sessionStorage.getItem("colonia"),
        alcaldia: sessionStorage.getItem("alcaldia"),
        entidadFederativa: sessionStorage.getItem("entidadFed"),
        colonias: [],
        copomex: false,
        local: false,
        modalShow: false,
        errorDatos: false,
        errorCodigo: false,
        okCodigo: '',
        entidadV: '',
        ciudadV: ''
      };
  },

  methods: {

    regresar(){
      window.history.go(-1);
    },

    continuar(){

      if (this.codigoPostal == '' || this.alcaldia == '' || this.entidadFederativa == '' || this.colonia == '' || this.calle == '' || this.numeroExterior == '' ){
          this.modalShow = true;
          this.errorDatos = true;
      } else {
          this.modalShow = false;
          this.errorDatos = false;
        this.siguiente();
      }
    },

    siguiente(){
      if ( this.numeroInterior == 'null' || this.numeroInterior == '' || this.numeroInterior == null){
        sessionStorage.setItem("numInt", 0);
      } else {sessionStorage.setItem("numInt", this.numeroInterior);}

        sessionStorage.setItem("calle", this.calle);
        sessionStorage.setItem("numExt", this.numeroExterior);
        sessionStorage.setItem("colonia", this.colonia);
        sessionStorage.setItem("codigoPostal", this.codigoPostal);
        sessionStorage.setItem("alcaldia", this.alcaldia);
        sessionStorage.setItem("entidadFed", this.entidadFederativa);
        this.$router.push({ path: '/Confirmacion'});
    },

      entidades(){
            this.cp = this.codigoPostal;
            //console.log('Accediendo Entidades Autocom');
            this.colonia = null;
            axios.get("https://ubicacion.autocom.mx/api/ubicaciones/"+this.cp).then((response) => {

                this.status = response.data.status;

                if( this.status == 404){
                   //console.log('Accediendo a Entidades COPOMEX'); 
                   this.copomexApi();
                } else {
                  this.copomex = false;
                  this.local = true;
                  this.colonias = response.data;
                  this.entidadV = response.data[0].entidad;
                  this.entidadFederativa = this.entidadV;
                  this.ciudadV = response.data[0].municipio;
                  this.alcaldia = this.ciudadV;
                  this.acronimo();
                }
            }).catch(error=>{
          console.log(error);
        });
        },

      entidadesBack(){
            this.cp = this.codigoPostal;
            axios.get("https://ubicacion.autocom.mx/api/ubicaciones/"+this.cp).then((response) => {
                this.status = response.data.status;
                if( this.status == 404){
                   this.copomexApi();
                } else {
                  this.copomex = false;
                  this.local = true;
                  this.colonias = response.data;
                  this.entidadV = response.data[0].entidad;
                  this.entidadFederativa = this.entidadV;
                  this.ciudadV = response.data[0].municipio;
                  this.alcaldia = this.ciudadV;
                  this.acronimo();
                }
            }).catch(error=>{
          console.log(error);
        });
        },

        copomexApi(){
          const apiKey = '9bffeb00-a370-40cd-bec8-5cbccbb9d977';
            this.cp = this.codigoPostal;
            axios.get("https://api.copomex.com/query/info_cp_geocoding/"+this.cp+"?type=simplified&token="+apiKey).then((response) => {

                  this.copomex = true;
                  this.local = false;
                  this.colonias = [...response.data.response.asentamiento];
                  this.entidadV = response.data.response.estado;
                  this.entidadFederativa = this.entidadV;
                  this.ciudadV = response.data.response.municipio;
                  this.alcaldia = this.ciudadV;
                  this.guardaAPI(response);
                  this.acronimo();
            }).catch(error=>{
              this.modalShow = true;
              this.errorCodigo = true;
              this.onReset();
              console.log(error);
            });

        },

        onReset(){
          this.codigoPostal = null;
        },

        async guardaAPI(response){
          //console.log('Guardar Datos');
             const nuevosDatos = {
                 codigopostal: response.data.response.cp,
                 entidad: response.data.response.estado,
                 ciudad: response.data.response.ciudad,
                 municipio: response.data.response.municipio,
                 colonia: [...response.data.response.asentamiento],
             }
             for(let i = 0; i < nuevosDatos.colonia.length; i++){
                 const nuevoCP ={
                     codigopostal: nuevosDatos.codigopostal,
                     entidad: nuevosDatos.entidad,
                     ciudad: nuevosDatos.ciudad,
                     municipio: nuevosDatos.municipio,
                     colonia: nuevosDatos.colonia[i],
                 }
                 this.agregar(nuevoCP);
             }
        },

        agregar(nuevoCP){
          axios.post('https://ubicacion.autocom.mx/api/ubicaciones/add',nuevoCP)
            .then(response =>{
              this.result = response;
            }).catch(error=>{
              console.log(error);
            });
        },

        acronimo(){
          //console.log('Buscando acronimo -->',this.entidadFederativa);
          axios.get("https://creditcheck.autocom.mx/api/acronimo/"+this.entidadFederativa)
            .then(response =>{
              this.edoacronimo = response.data[0].codigo;
              //console.log('Acronimos -->',this.edoacronimo);
              sessionStorage.setItem("edoAcronimo", this.edoacronimo);
            }).catch(error=>{
              console.log(error)
            });          
        }

  },

  created() {

      if(this.codigoPostal == null){
        //console.log('ok');
        this.okCodigo = 0;
      } else {
        this.entidadesBack();
        this.copomex = false;
        this.local = true;
      }
   },
}
</script>

<style scoped>


</style>